module.exports = __webpack_public_path__ + "static/media/lmb.f6c8dd57.png";